<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({});
</script>

<template>
  <div class="data-separator" />
</template>

<style lang="scss" scoped>
  .data-separator {
    display: inline-block;
    height: 1 * $base-unit;
    border-right: 1px solid $gray-light;
  }
</style>
